import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CSWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-654">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-655">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-656">
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-657">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-658">
              <img src="https://cdn.magicpatterns.com/uploads/nGH1azYqSUHHTBwH1CHGrH/BeClinical-Lifestyle-31-6.jpg" alt="Be CLINICAL ClearSilk Treatment" className="w-full h-full object-cover" data-id="element-659" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-660">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-661">
              WHY CHOOSE BE CLINICAL FOR CLEARSILK LASER FACIAL?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-662"></div>

            <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-663">
              <p data-id="element-664">
                Choosing Be CLINICAL for your ClearSilk laser rejuvenation
                treatment ensures a premium experience aligned with our
                commitment to excellence in skincare. Our highly skilled team of
                aesthetic professionals, renowned for their expertise in
                advanced laser technologies, will tailor a personalized
                treatment plan to address your specific skin concerns and goals.
              </p>
              <p data-id="element-665">
                With Be CLINICAL, you can trust that your ClearSilk treatment
                will be performed with precision and care, utilizing the latest
                Sciton technology for optimal results. Experience the difference
                of Be CLINICAL's dedication to skincare innovation and
                personalized care, and embark on your journey to radiant,
                rejuvenated skin with confidence. Schedule your complimentary
                consultation with us today!
              </p>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-666">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}